// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 427) return "static/chunks/427.85eb9d123a9bae2d.js";
	if (chunkId === 54) return "static/chunks/54.e1fd9c6065d57ce8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"431":"29564a12b8cca8e4","592":"2d431ae5cb9fcd66","704":"7a39f83f8b62f786","939":"c6a769076338fe6f","962":"37d1c9864688af4f"}[chunkId] + ".js";
};